import React from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import {
  ConfirmationContainer,
  ConfirmationMessage
} from '../../../../form/fields/css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const Confirmation = ({ fileName, setConfirmDelete, onDeleteFile }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      LIST: {
        confirmationDialog: { CONFIRM, CANCEL }
      }
    },
    general: { confirmDeleteMessage }
  } = localizedStrings;

  return (
    <ConfirmationContainer>
      <ConfirmationMessage>{`${confirmDeleteMessage} ${fileName}?`}</ConfirmationMessage>
      <Button onClick={onDeleteFile}>{CONFIRM}</Button>
      <Button
        onClick={() => {
          setConfirmDelete(false);
        }}
      >
        {CANCEL}
      </Button>
    </ConfirmationContainer>
  );
};

Confirmation.propTypes = {
  fileName: PropTypes.string.isRequired,
  setConfirmDelete: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired
};

export default Confirmation;
